import React from 'react';
import styled from 'styled-components';

import Section from './section';

const Container = styled(Section)`
  max-width: 90%;
  z-index: 2;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media (max-width: 767px) {
    max-width: 100%;
    flex-direction: column;
  }
`;

const Column = styled.div`
  max-width: 60%;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

const ColumnedSection = ({ title, children }) => (
  <Container>
    {title}
    <Column>{children}</Column>
  </Container>
);

export default ColumnedSection;
